import { useContext, useMemo } from "react";
import { useTheme } from "../../ThemeProvider/useTheme";
import { buildTypography } from "../buildTypography/buildTypography";
import { devMessage, isDevEnv } from "../../../utils/devMessage";
import { CarinaContext } from "../../CarinaProvider";
export function useTypography() {
    var theme = useTheme();
    var ref;
    var ref1 = (ref = useContext(CarinaContext)) !== null && ref !== void 0 ? ref : {}, breakpoints = ref1.breakpoints, flags = ref1.flags;
    return useMemo(function() {
        try {
            return buildTypography({
                theme: theme,
                breakpoints: breakpoints,
                flags: flags
            });
        } catch (error) {
            if (isDevEnv()) {
                devMessage("[Typography] Styles may not be appearing as expected. \n".concat(!theme ? 'No Theme object received via ThemeProvider. \nMake sure you have ThemeProvider at the root of the component tree.' : "There's an issue with the format of your Theme object. \nCheck your Tokens version and any modifications you may have made. \n Received \n".concat(JSON.stringify(theme, undefined, 2))));
            }
            return {};
        }
    }, [
        theme,
        breakpoints,
        flags
    ]);
}
export default useTypography;
